// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mrWML","content":"styles_content__34PRb","tableWrap":"styles_tableWrap__3vjQt"};